import "./footer.css";

import React from "react";
import { Link } from "react-router-dom";

import { PAGE_ROUTES, CONTACT_DETAILS, PAIA_MANUAL } from "../../utils/stateTypes";
import SocialLinks from "../general/SocialLinks";

const Footer = () => {
  return (
    <footer className={"footer"}>
      <div className={"container footer-main"}>
        <Link
          to={PAGE_ROUTES.HOME}
          className={"footer-logo"}
        >
          <img
            src={"/images/logo-footer.png"}
            alt={"Janine Botha Attorneys Inc. - Attorney, Notary & Conveyancer"}
            width={350}
            height={155}
            loading={"lazy"}
          />
        </Link>
        <div className={"footer-contact"}>
          <p>
            {"Email: "}
            <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>
          </p>
          <p>
            {"Tel: "}
            <a href={CONTACT_DETAILS.PHONE_LINK}>{CONTACT_DETAILS.PHONE}</a>
          </p>
          <SocialLinks />
        </div>
      </div>
      <div className={"footer-bottom"}>
        <nav
          className={"footer-legal"}
          aria-label={"Legal"}
        >
          <Link to={PAGE_ROUTES.TERMS}>Terms &amp; Conditions</Link>
          <span aria-hidden={"true"}>•</span>
          <a
            href={PAIA_MANUAL}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            PAIA
          </a>
          <span aria-hidden={"true"}>•</span>
          <Link to={PAGE_ROUTES.PRIVACY}>Privacy Policy</Link>
        </nav>
        <p>
          {`© ${new Date().getFullYear()} Janine Botha Attorneys. Built by `}
          <a
            href={"http://tap-x.com/"}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            TapX
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
